import { Button, Popover, PopoverContent, PopoverTrigger } from "@ondit/ui";
import { type ReactNode, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";

export function StageFlyout({
	label,
	icon,
	current,
	children,
}: {
	label: string;
	icon: ReactNode;
	current: boolean;
	children: ReactNode;
}) {
	const [open, setOpen] = useState(false);
	const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
	const hover = useRef(false);
	const location = useLocation();
	const cancelClose = () => clearTimeout(timer.current);
	const closeSoon = () => {
		cancelClose();
		// Let the pointer cross the gap between the rail and the portal.
		timer.current = setTimeout(() => setOpen(false), 180);
	};
	useEffect(() => () => clearTimeout(timer.current), []);
	useEffect(() => {
		if (location.key) setOpen(false);
	}, [location.key]);
	return (
		<Popover open={open} onOpenChange={setOpen}>
			<PopoverTrigger asChild>
				<Button
					variant="ghost"
					className={`stage-rail-trigger w-full${current ? " is-current" : ""}`}
					aria-label={label}
					onPointerEnter={(event) => {
						if (event.pointerType !== "mouse") return;
						cancelClose();
						hover.current = true;
						setOpen(true);
					}}
					onPointerLeave={closeSoon}
					onKeyDown={() => {
						hover.current = false;
					}}
				>
					{icon}
				</Button>
			</PopoverTrigger>
			<PopoverContent
				side="right"
				align="start"
				className="stage-flyout w-(--console-sidebar-w) p-(--s-4)"
				aria-label={label}
				onPointerEnter={cancelClose}
				onPointerLeave={closeSoon}
				onOpenAutoFocus={(event) => {
					if (hover.current) event.preventDefault();
				}}
				onCloseAutoFocus={(event) => {
					if (hover.current) event.preventDefault();
				}}
			>
				<div className="stage-flyout-label">{label}</div>
				<nav aria-label={label}>{children}</nav>
			</PopoverContent>
		</Popover>
	);
}
